export default __webpack_public_path__ + "static/zero_hassle_back-4cba95a69d28aa6d1325214e5f12396c.webp";